import { useSeoMeta } from '@unhead/react';

/**
 * Renders the standalone VicRoads digital licence prototype (public/digital-licence.html)
 * full-screen inside the app shell.
 */
const Index = () => {
  useSeoMeta({
    title: 'VicRoads — Digital Licence',
    description: 'A digital driver licence concept app.',
  });

  return (
    <div className="relative h-screen w-full overflow-hidden bg-[#eef0f3]">
      <iframe
        src="/digital-licence.html?v=111"
        title="VicRoads digital driver licence"
        allow="accelerometer; gyroscope; magnetometer"
        className="h-full w-full border-0"
      />
      <a
        href="https://shakespeare.diy"
        target="_blank"
        rel="noreferrer noopener"
        className="absolute bottom-2 left-2 z-10 hidden rounded-full bg-white/70 px-3 py-1 text-[11px] font-medium text-[#1a2b4c] shadow-sm backdrop-blur transition-colors hover:bg-white sm:block"
      >
        Vibed with Shakespeare
      </a>
    </div>
  );
};

export default Index;
